module.exports = "/assets/8bdc71eeca3408cdde244db4611fd3da.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/ZE.png
// module id = 766
// module chunks = 0